import Table from '../Table/Table';
import { useTranslation } from 'react-i18next';
import React, { useMemo, useState } from 'react';
import emptyStateImage from './empty-state.png';
import styles from './Terminals.module.scss';
import Input from '../Form/Input/Input';
import PropTypes from 'prop-types';
import TableActionButtons from './TableActionButtons';

const Terminals = (props) => {
    const { t } = useTranslation();

    const [search, setSearch] = useState('');
    const filteredTerminals = useMemo(
        () =>
            props.terminals.filter((terminal) =>
                terminal.name.toLowerCase().includes(search.toLowerCase())
            ),
        [search, props.terminals]
    );

    const columns = useMemo(
        () => [
            {
                Header: t('terminals.terminal'),
                accessor: 'name',
                sortable: true,
                sortType: 'alphanumericCaseInsensitive',
                Cell: ({ row }) => row.original.name,
            },
            {
                Header: t('terminals.country'),
                accessor: 'country.name',
                sortable: true,
                sortType: 'alphanumericCaseInsensitive',
                Cell: ({ row }) => row.original.country.name,
            },
            {
                Header: (
                    <Input
                        type='text'
                        value={search}
                        onChange={setSearch}
                        placeholder={t('terminals.search')}
                        icon={'search'}
                        className={styles.Search}
                    />
                ),
                accessor: 'id',
                sortable: false,
                Cell: ({ row }) => (
                    <TableActionButtons terminal={row.original} visibleInfo={props.visibleInfo} />
                ),
            },
        ],
        [search, props.visibleInfo]
    );

    return (
        <div>
            <Table
                columns={columns}
                data={filteredTerminals}
                defaultSort={[
                    {
                        id: 'name',
                        desc: false,
                    },
                ]}
                emptyState={
                    <div>
                        <img src={emptyStateImage} alt={''} />
                        <div className={styles.EmptyHeadline}>
                            {t('terminals.emptyStateHeadline')}
                        </div>
                        <div className={styles.EmptySubHeadline}>
                            {t('terminals.emptyStateSubHeadline')}
                        </div>
                    </div>
                }
            />
        </div>
    );
};

Terminals.propTypes = {
    terminals: PropTypes.array.isRequired,
    visibleInfo: PropTypes.object,
};
export default Terminals;
